import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import moment from 'moment';
import { Form, Button, Segment } from 'semantic-ui-react';
import { sixMonthsInMinutes } from '_constants';

import MachineCountField from '_forms/machineCountField';
import SessionLengthField from '_forms/sessionLengthField';
import SessionRenewableField from '_forms/sessionRenewableField';
import IlokField from '_forms/ilokField';
import BaseDateField from '_forms/baseDate';

const NewLicense = ({
  onChange,
  onCancel,
  onSave,
  license,
}) => {
  const productOptions = [
    {text: 'Max 9', value: 'max9'},
    {text: 'Max 9 + RNBO', value: 'max9-rnbo'},
    {text: 'Max 8', value: 'max8'},
    {text: 'Max 8 + RNBO', value: 'max8-rnbo'},
    {text: 'Max 7', value: 'max7'},
  ];

  const typeOptions = [
    {text: 'Demo', value: 'demo'},
    {text: 'Full', value: 'full'},
    {text: 'Term', value: 'term'},
  ];

  const getExpiresOn = R.compose(
    R.tryCatch(x => moment(x), R.always(moment())),
    R.propOr(new Date(), 'expires_on')
  );

  return (
    <Segment>
      <Form>
        <Form.Group>
          <Form.Select width={4} label="Product" options={productOptions} name="name" value={license.name} onChange={onChange} />
          <Form.Select width={4} label="Type" options={typeOptions} name="type" value={license.type} onChange={onChange} />
          <MachineCountField width={4} name="machine_count" machineCount={license.machine_count || 4} onChange={onChange} />
          {license.type !== "full" ? (
            <BaseDateField
              width={4}
              name="expires_on"
              value={getExpiresOn(license)}
              onChange={onChange}
              labelTxt="Expires"
            />
          ) : null}
        </Form.Group>
        <Form.Group>
          <SessionLengthField width={4} name="session_length_min" lengthInMinutes={license.session_length_min || sixMonthsInMinutes } onChange={onChange} />
          <IlokField width={9} name="ilok_accounts" ilokAccounts={license.ilok_accounts || []} onChange={onChange} />
          <SessionRenewableField width={3} name="session_renewable" renewable={license.session_renewable || false} onChange={onChange} />
        </Form.Group>
        <Button.Group>
          <Button onClick={onCancel}>Cancel</Button>
          <Button.Or />
          <Button positive onClick={onSave}>Save</Button>
        </Button.Group>
      </Form>
    </Segment>
  );
};

NewLicense.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  license: PropTypes.object.isRequired,
};

export default NewLicense;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/licenses/newLicense.js